<div [formGroup]="form" *ngIf="radioModel">
  <ws10-radio-button [radioModel]="radioModel" [formControlName]="formControlName" [required]="formField.required ? '' : null">
  </ws10-radio-button>
</div>
